import React, {
  Component
} from "react";
import {
  connect
} from "react-redux";
import {
  Group,
  // Rect,
  Shape
} from "react-konva";
import {InchUtility} from "../../../lib/pipe-dataset";
import {PIPE_FLOW_ARROW_ORIENTATION} from '../../../lib/types';

class FlowArrowComponent extends Component {

  get arrowOrientation() {
    const newOrientation = this.props.arrowOrientation === undefined ? PIPE_FLOW_ARROW_ORIENTATION.DOWN : this.props.arrowOrientation;

    switch (newOrientation) {
      case PIPE_FLOW_ARROW_ORIENTATION.DOWN:
        return {
          rotation: 0,
          offset: {
            x: 0,
            y: 0
          }
        };
      case PIPE_FLOW_ARROW_ORIENTATION.UP:
        return {
          rotation: 180,
          offset: {
            x: this.props.pipeOD,
            y: this.props.pipeOD * .35
          }
        };
      case PIPE_FLOW_ARROW_ORIENTATION.LEFT:
        return {
          rotation: 90,
          offset: {
            x: (this.props.pipeOD / 2) + 2,
            y: -(this.props.pipeOD * .35)
          }
        };
      case PIPE_FLOW_ARROW_ORIENTATION.RIGHT:
        return {
          rotation: 270,
          offset: {
            x: (this.props.pipeOD / 2) - 2,
            y: (this.props.pipeOD * .35) * 2
          }
        };
      default:
        return {
          rotation: 0,
          offset: {
            x: 0,
            y: 0
          }
        }
    }
  }

  render() {
    return (
      <Group
        x={this.props.x}
        y={this.props.y}
        width={this.props.pipeOD}
        height={this.props.manifoldRowHeight}
      >
        {/*debugging frame*/}
        {/*<Rect*/}
        {/*x={0}*/}
        {/*y={0}*/}
        {/*width={this.props.pipeOD}*/}
        {/*height={this.props.pipeOD}*/}
        {/*stroke="red"*/}
        {/*strokeWidth={0.3}*/}
        {/*/>*/}
        <Group
          y={this.props.pipeOD * .35 + this.arrowOrientation.offset.y}
          x={this.arrowOrientation.offset.x}
          rotation={this.arrowOrientation['rotation']}
        >
          <Shape
            sceneFunc={(context, shape) => {
              context.beginPath();
              context.moveTo(this.props.pipeOD * .35, this.props.pipeOD * .1);
              context.lineTo(this.props.pipeOD - (this.props.pipeOD * .35), this.props.pipeOD * .1);
              context.lineTo(this.props.pipeOD / 2, this.props.pipeOD * .5);
              context.lineTo(this.props.pipeOD * .35, this.props.pipeOD * .1);
              context.fillStrokeShape(shape);
            }}
            fill={'rgba(30, 140,240,0.5)'}
          />
        </Group>
      </Group>
    );
  }
}

const mapStateToProps = state => {
  return {
    rowSpacing: new InchUtility(state.pipeBed.rowSpacing),
    pipeFlowDirection: state.pipeGlobals.pipeFlowDirection,
    pipeOD: state.pipeGlobals.pipeNominalDiameter.pipeOD.px,
    manifoldRowHeight: state.pipeGlobals.pipeNominalDiameter.horizontalRowHeight.px
  };
};

export default connect(
  mapStateToProps, {}
)(FlowArrowComponent);



// WEBPACK FOOTER //
// ./src/components/Drawings/Pipes/flow-arrow-component.js